module.exports = __webpack_public_path__ + "static/media/error.45b31864.svg";